import styled from "styled-components";

export const Component = styled.div`
  &.nav-tabs {
    border-bottom: 5px solid #e2e2e2;
    .nav-item {
      margin-bottom: -5px;
    }
  }
`;